class DieselKlaviyo {
  showBackInStock(formId) {
    if (!formId) return;
    if (window.KlaviyoOnSite && window.KlaviyoOnSite.BIS) {
      window.KlaviyoOnSite.BIS.openModal();
    } else if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(formId); 
    } else {
      showNewsletterModal(domain);
    }
  }
}
class DieselSelectSize {
  constructor() {
    this.selectSize = document.querySelector('[data-diesel-select-size]');
    if (!this.selectSize) return;
    window.addEventListener(
      'scroll',
      () => this.destroy(),
      { once: true, passive: true }
    );
    if (window.scrollY > 0) {
      this.destroy();
    }
  }
  destroy() {
    if (!this.selectSize) return;
    this.selectSize.classList.add('hidden--opacity');
    setTimeout(() => {
      this.selectSize?.remove();
      this.selectSize = null;
    }, window.theme.data.transitionDuration);
  }
}
class DieselShoppingPreference {
  constructor() {
    this.sections = document.querySelectorAll(`[data-featured-tab-section-id]`);
    this.preferenceKey = 'preferredTabs';
    this.savedPreference = sessionStorage.getItem(this.preferenceKey);
    this.preferenceElements = document.querySelectorAll('[data-diesel-shopping-preference]');
  }
  handleCurrentPreference(featuredTabId) {
    if (!featuredTabId) return;
    sessionStorage.setItem(this.preferenceKey, featuredTabId);
    this.handleSections(featuredTabId);
    this.handleGlobalPreference(featuredTabId);
  }
  handleSections(featuredTabId) {
    const processedSections = new Set();
    this.sections.forEach((section) => {
      const sectionId = section.dataset.featuredTabSectionId;
      if (!sectionId || processedSections.has(sectionId)) return;
      const sectionHasTab = document.querySelector(
        `[data-featured-tab-trigger][data-featured-tab-section-id="${sectionId}"][data-featured-tab-id="${featuredTabId}"]`
      );
      if (!sectionHasTab) return;
      processedSections.add(sectionId);
      const tabElements = document.querySelectorAll(
        `[data-featured-tab-element][data-featured-tab-section-id="${sectionId}"]`
      );
      tabElements.forEach((tab) => {
        tab.classList.toggle('hidden', tab.dataset.featuredTabId !== featuredTabId);
      });
      const tabTriggers = document.querySelectorAll(
        `[data-featured-tab-trigger][data-featured-tab-section-id="${sectionId}"]`
      );
      tabTriggers.forEach((trigger) => {
        trigger.classList.toggle('pill--active', trigger.dataset.featuredTabId === featuredTabId);
      });
    });
  }
  handleGlobalPreference(featuredTabId) {
    this.preferenceElements.forEach((element) => {
      const preference = element.getAttribute('data-diesel-shopping-preference');
      if (preference !== featuredTabId) {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    });
  }
  removeGlobalPreference() {
    this.preferenceElements.forEach((element) => {
      element.classList.remove('hidden');
    });
    sessionStorage.removeItem(this.preferenceKey);
  }
  showPreferredShopping() {
    if (!this.savedPreference) return;
    this.handleCurrentPreference(this.savedPreference);
    this.handleGlobalPreference(this.savedPreference);
  }
}